<div
  class="d-flex align-items-center justify-content-center flex-column payment-settings-container"
  [nbSpinner]="connecting"
>
  <h5 class="mb-4 text-center">To Get Started, Connect to with Stripe</h5>
  <!-- <ng-container *ngIf="currentAccount | async as currentAccount">
    {{ currentAccount.type }}
    {{ currentAccount.details_submitted }}
    {{ currentAccount.business_profile.name }}
  </ng-container> -->

  <div class="d-flex flex-column flex-md-row">
    <button nbButton size="giant" status="primary" shape="round" (click)="connectToStripe()" class="m-2">
      {{ !(currentAccount | async) ? 'Connect Stripe' : 'Update Stripe Info' }}
    </button>
    <!--
    <button *ngIf="currentAccount | async" nbButton size="giant" shape="round" status="basic" (click)="expressLogin()" class="m-2">Stripe Dashboard</button>-->
    <button *ngIf="currentAccount | async" nbButton size="giant" status="basic" (click)="reset()" class="m-2">Disconnect Stripe</button>
  </div>
</div>
